import CreateTemplateModalController from '../../controllers/workflows/list/create-template-model-controller';
import createTemplateModelTemplate from '../../views/workflows/list/create-template-modal.tpl.html';

class createTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.modal = $injector.get('$uibModal');

        this.key = 'create-template';
        this.title = this.translate.instant('templates.workflows.list.create-template.title');
        this.level = 'highlight';
        this.icon = 'fal fa-plus-circle';
    }

    action(payload, store) {
        this.modal
            .open({
                controller: CreateTemplateModalController,
                controllerAs: 'vm',
                templateUrl: createTemplateModelTemplate
            })
            .result
            .then(({template}) => {
                this.state.go('app.templates.details', {id: template.id});
            })
            .catch(() => {

            })
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('createTemplate', [
        '$injector',
        ($injector) => new createTemplate($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/list/create-template.js